import React from "react";

const CustomerLogo = () => {
  return (
    <section className="brand-logo ptb-120">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-7 col-md-10">
            <div className="section-heading text-center">
              <h2>Over 500+ Companies Trusted Us</h2>
              <p>Over 500+ Companies Trusted Us</p>
            </div>
          </div>
        </div>
        <div className="row">
          <ul className="brand-logo-grid list-unstyled">
            <li>
              <img src="assets/img/brand-logo/1-2.png" alt="brand logo" />
            </li>
            <li>
              <img src="assets/img/brand-logo/2-1.png" alt="brand logo" />
            </li>
            <li>
              <img src="assets/img/brand-logo/3-1.png" alt="brand logo" />
            </li>
            <li>
              <img src="assets/img/brand-logo/4-1.png" alt="brand logo" />
            </li>
            <li>
              <img src="assets/img/brand-logo/5-1.png" alt="brand logo" />
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default CustomerLogo;
